import { Component, ReactNode, PropsWithChildren, ErrorInfo } from 'react';
import { Error } from '@/components/error';
import { ErrorBoundaryState } from './types';
import { reportError } from '@/services/monitoring';

export class ErrorBoundary extends Component<PropsWithChildren, ErrorBoundaryState> {
    constructor(props: PropsWithChildren) {
        super(props);
        this.state = { hasError: false, error: '' };
    }

    static getDerivedStateFromError(error: Error): ErrorBoundaryState {
        return { hasError: true, error };
    }

    componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
        console.error('ErrorBoundary caught:', error, errorInfo);

        reportError(error, {
            source: 'react-error-boundary',
            componentStack: errorInfo.componentStack,
        });
    }

    render(): ReactNode {
        const { hasError, error } = this.state;
        const { children } = this.props;

        if (hasError) {
            return <Error message={error.toString()} />;
        }
        return children;
    }
}
